import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  NgZone,
  Output,
  EventEmitter,
  HostListener,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { HttpService } from "../../../service/http.service";
import { FeedService } from "../../../service/feed.service";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { CommentService } from "../../../service/comment.service";
import { eventEmitterService } from "../../../service/eventEmitter.service";
import { EventService } from "../../../service/event.service";

import * as _ from "lodash";
import { BuildingsService } from "../../../service/buildings.service";
import { MaintananceService } from "../../../service/maintanance.service";
import { GroupService } from "../../../service/group.service";
import { VoteUpdateService } from "../../../service/vote-update.service";
import { FeedUpdateServiceService } from "../../../service/feed-update-service.service";
import {
  FacebookService,
  LoginResponse,
  LoginOptions,
  UIResponse,
  UIParams,
  FBVideoComponent,
} from "ngx-facebook";
import { PostFilterService } from "../../../service/post-filter.service";
import { PercentageIncreaseUpdaterService } from "../../../service/percentage-increase-updater.service";
import { UserInfoService } from "../../../service/user-info.service";
import { UUID } from "angular2-uuid";
import * as iCalEvent from "icalevent";
//import 'icalevent';
declare var require: any;
var iCalEvent = require("icalevent");

import { UserService } from "../../../service/user.service";
import { ioService } from "../../../service/io.service";
import { Subject, Subscription } from "rxjs";

declare var jQuery: any;
declare var $: any;

@Component({
  selector: "app-post",
  templateUrl: "./post.component.html",
  styleUrls: ["./post.component.css"],
})
export class PostComponent implements OnInit, AfterViewInit, OnDestroy {
  messageToSend;
  post: FormGroup;
  editPost: FormGroup;
  eventsEditForm: FormGroup;
  events: FormGroup;
  maintananceForm: FormGroup;
  buildingAlertsForm: FormGroup;
  maintananceFormEdit: FormGroup;
  buildArray = [];
  buildingFilterStore = [];
  category;
  Activities: any;
  buildingList: any;
  allBuildingsInfo;
  status = false;
  ActivityLength = 0;
  profile;
  apiUrl = environment.s3BucketApi;
  s3apiUrl = environment.s3BucketApi;
  id = localStorage.getItem("residents")
    ? localStorage.getItem("residents")
    : sessionStorage.getItem("userId");
  isManager = localStorage.getItem("isManager");
  buildingId = localStorage.getItem("userBuildingId");
  ismaintenance = localStorage.getItem("maintenance");
  userType = localStorage.getItem("type");
  isManagerStatus;
  ActivityId: Subject<any> = new Subject();
  buildingIndex = 0;
  private timer;
  private sub: Subscription;
  successMessage;
  selectedBuilding = {
    buildingImage: null,
    buildingName: null,
    isMaintenanceActive: true,
  };
  filteredBuildingName = null;
  selectedbuildingImage;
  /* summernoteContent;
   savedPost = false;
   postEditContent;
   postEditTitle;*/
  titleError;
  contentError;
  titleSpaceError;
  contentEmpty;
  updatedActivityLength: number = 0;
  currentActivityLength: number = 0;
  currentEventLength: number = 0;
  eventList;
  maintananceList;
  maintananceId;
  currentMaintananceLength;
  groupResult = [];
  leavingGroupId = "";
  leavingGroupRef = "";
  leavingGroupName = "";
  selectedBuildingAlert = "";
  GroupStatus = false;
  groupCheckStatus;
  groupList = [];
  groupArray = [];
  buildingAlerts = [];
  buildingAlertsLength = 0;
  groupNameEdit = [];

  present = "Attend";
  AttendingUsersList = [];
  newCommentCount = [];
  names = "";
  editNames = "";
  buildingArray = [];
  buildingNames = [];
  selectedBuildingNameAlert = [];

  baseUrl = environment.s3BucketApi;

  startDateError;
  endDateError;
  eventTitleError;
  eventDescriptionError;
  startTimeError;
  endTimeError;
  error;
  eventToEdit;
  eventsId;
  dateValidation;
  dateValidationError;

  totalVotesCount: number = 0;
  totalMaintananceVotesCount: number = 0;
  residentCount: number = 0;
  startDateRefEdit;
  startTimeRefEdit;
  endDateRefEdit;
  endTimeRefEdit;
  AttendingUsers;
  singleBuilding = { buildingName: null, formattedAddress: "" };

  checkedIdx = 0;
  selectedCategory;
  options = [
    "Appliances",
    "Common Areas",
    "Doors & Locks",
    "Electrical",
    "Heating - A/C",
    "Pest Control",
    "Plumbing",
    "Windows",
    "Other",
  ];

  // Building Alert declarations
  myBuildings = [];
  myBuildingsLength = 1;
  selectedBuildings = [];
  allBuildings = [];
  expiryDateInvalid = false;
  subjectInvalid = false;
  messageInvalid = false;
  isCreated = false;
  isError = false;
  userBuildingId = localStorage.getItem("userBuildingId");
  // -------------------------

  //Vote counts
  postVoteCount;
  eventsVoteCount: number = 0;
  updatedEventVote: number = 0;
  maintananceVoteCount;

  //Flagpost
  flagPostIDList = [];
  isBuildingHasBuildingManager = false;

  // ---------------
  attendingUsers;
  fileName;
  AllFeeds = [];
  feedArrayLength: number = 0;
  eventArrayLength: number = 0;
  maintenanceArrayLength: number = 0;
  tempPostData: any;
  @ViewChild("tabReference", { static: false })
  public tabs: ElementRef;

  @ViewChild("feed", { static: false }) public searchElementRef: ElementRef;

  @ViewChild("nonAttendingState", { static: false })
  public nonAttendingState: ElementRef;

  @ViewChild("presentButton", { static: false })
  public presentButton: ElementRef;

  @ViewChild("attendingState", { static: false })
  public attendingState: ElementRef;

  @ViewChild("pos", { static: false }) public postPlaceholder: ElementRef;

  postFilterOption = "All";
  selectedBuildingId;
  tempArray = [];
  fileList: FileList;
  file: File = null;
  showFileName = true;
  fileChanged;
  expireDate;
  groupNames = [];
  Names = "";

  // Lazy Load Vars
  onceCheck = false;
  skip = 0;
  limit = 5;
  nextFeedLoading = false;
  winHeight = ($(document).height() - $(window).height()) * 0.75;
  totalFeedCount = 0;
  tempFeeds;
  set_clearTimeInterval;
  ifRequestSent = false;
  updatedPosts = [];
  updatedCommentCount = [];
  updatedReplyCount = [];
  blockServerCalls = true;
  typePost = "All";
  isPostSuccess: boolean = false;
  isEditPostSuccess = false;
  twitterContent: boolean = true;
  userProfile;
  uuid;
  tempPath = null;
  isShowCalendar: boolean = true;
  ratingcount = 0;
  // To Review
  maintanen: any;

  showLoading = false;
  users = [];

  @Output() messageEmmiter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private _http: HttpService,
    private _feed: FeedService,
    private ngZone: NgZone,
    private commentService: CommentService,
    private chatService: eventEmitterService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private router: Router,
    private buildingService: BuildingsService,
    private maintanance: MaintananceService,
    private _groupService: GroupService,
    private votService: VoteUpdateService,
    private userService: UserService,
    private fbook: FacebookService,
    private update: FeedUpdateServiceService,
    private postFilter: PostFilterService,
    private percentageSecrvice: PercentageIncreaseUpdaterService,
    private userInfo: UserInfoService,
    private _ioService: ioService
  ) {
    fbook.init({
      appId: "262874930884852",
      xfbml: true,
      version: "v2.9",
    });
  }

  scrollToFeed() {
    document
      .querySelector("#main-activity-feed")
      .scrollIntoView({ behavior: "smooth", inline: "start", block: "start" });
  }

  private feedSubscription: Subscription;

  // Add this method to your class
  private checkBuildingMatch(feed, selectedBuildingId): boolean {
    if (!feed || !feed.buildingId || !selectedBuildingId) return false;

    // Handle different formats of buildingId
    if (Array.isArray(feed.buildingId)) {
      return feed.buildingId.some((building) => {
        if (typeof building === "object" && building !== null) {
          return building.id === selectedBuildingId;
        } else {
          return building === selectedBuildingId;
        }
      });
    } else if (
      typeof feed.buildingId === "object" &&
      feed.buildingId !== null
    ) {
      return feed.buildingId.id === selectedBuildingId;
    } else {
      return feed.buildingId === selectedBuildingId;
    }
  }

  // Add this method to your class
  private applyStyle(): void {
    $(".feed_posted_text p span").each(function () {
      var fS = $(this).css("font-size");
      $(this).css("line-height", fS);
    });
  }

  ngOnInit() {
    // Script for making the side menu hold still on hovering the tour box

    $(".tooltipSetter").mouseenter(function () {
      $("body").addClass("firstTime");
    });
    $(".tooltipSetter").mouseleave(function () {
      $("body").removeClass("firstTime");
    });

    this.getUsers().then((users: any) => {
      this.users = users;
    });

    this.userInfo.user.subscribe((data: any) => {
      this.userProfile = data;
    });
    /**
     * socket service to get latest posts
     *
     */
    /**
     * socket service to get latest posts
     *
     */
    this.feedSubscription = this._feed._feed$.subscribe((feedsRes) => {
      console.log(feedsRes, "............");

      // Improved handling of different feed types
      const handleFeed = (feedType, feedData) => {
        if (!feedData) return;

        // Check if this item already exists in the list
        const existingFeedIndex = this.AllFeeds.findIndex(
          (item) => item.id === feedData.id
        );

        if (existingFeedIndex >= 0) {
          // Update existing feed
          console.log(
            `Updating existing ${feedType} at index ${existingFeedIndex}`
          );

          if (feedData.uuid === this.uuid) {
            // This is our own post being updated (from our session)
            this.AllFeeds[existingFeedIndex] = feedData;
            this.tempPath = null;
            this.showLoading = false;
          } else {
            // This is an update from someone else
            this.feedUpdate(feedData);
          }

          // Create a new array reference to trigger change detection
          this.AllFeeds = this.AllFeeds.slice();
        } else {
          // Add as a new item
          if (feedData.uuid === this.uuid) {
            // Our own post being added
            let check = this.AllFeeds.map(function (item) {
              return item.uuid === feedData.uuid ? feedData : item;
            });
            const seen = new Set();
            const uniqueData = [];

            check.forEach(function (item) {
              if (!seen.has(item.id)) {
                seen.add(item.id);
                uniqueData.push(item);
              }
            });
            for (let i = uniqueData.length - 1; i >= 0; i--) {
              this.AllFeeds.unshift(uniqueData[i]);
            }

            this.tempPath = null;
            this.showLoading = false;
          } else {
            // Check if the feed belongs to the currently selected building
            const belongsToSelectedBuilding = this.checkBuildingMatch(
              feedData,
              this.selectedBuildingId
            );
            console.log(
              `Does ${feedType} belong to selected building (${this.selectedBuildingId})?`,
              belongsToSelectedBuilding,
              "Feed Building IDs:",
              feedData.buildingId
            );

            if (belongsToSelectedBuilding) {
              console.log(`Adding new ${feedType} to the top of the list`);
              this.AllFeeds.unshift(feedData);

              // Create a new array reference to trigger change detection
              this.AllFeeds = this.AllFeeds.slice();

              // Add subtle highlight animation to newly added posts
              setTimeout(() => {
                const firstPost = document.querySelector(".single_feed_wrap");
                if (firstPost) {
                  firstPost.classList.add("new-post");
                  setTimeout(() => {
                    firstPost.classList.remove("new-post");
                  }, 2000);
                }
              }, 100);
            }
          }
        }
      };

      // Handle different types of feed updates
      if (feedsRes["feeds"]) {
        handleFeed("feed", feedsRes["feeds"]);
      }

      if (feedsRes["events"]) {
        handleFeed("event", feedsRes["events"]);
        this.isShowCalendar = true;
      }

      if (feedsRes["maintenance"]) {
        handleFeed("maintenance", feedsRes["maintenance"]);
      }

      if (feedsRes["deleted"]) {
        this.AllFeeds = this.AllFeeds.filter(
          (item) => item.id !== feedsRes["deleted"].id
        );
      }

      if (
        feedsRes["alerts"] ||
        feedsRes["editAlert"] ||
        feedsRes["deleteAlert"]
      ) {
        this.getRecentBuildingAlerts(this.selectedBuildingId).then(
          (data: any) => {
            this.buildingAlerts = data.alerts[0].buildingAlerts;
            this.buildingAlertsLength = this.buildingAlerts
              ? this.buildingAlerts.length
              : 0;
          }
        );
      }

      setTimeout(() => {
        this.applyStyle();
      }, 1000);
    });

    var applyStyle = function () {
      $(".feed_posted_text p span").each(function () {
        var fS = $(this).css("font-size");
        $(this).css("line-height", fS);
      });
    };

    this.chatService.replyCount$.subscribe((data) => {
      this.updatedReplyCount.push(data);
      setTimeout(() => {
        this.updatedReplyCount = this.updatedReplyCount.filter(
          (v, i, a) => i === a.findIndex((t) => t.id === v.id)
        );
        this.AllFeeds.forEach((val) => {
          if (this.updatedReplyCount.length > 0) {
            this.updatedReplyCount.forEach((comment) => {
              if (val.id === comment.comment.activityFeed) {
                if (comment.flag) {
                  //val.isReplyFlagged = comment.isFlaggedBy;
                }
              }
            });
          }
        });
        this.updatedReplyCount = [];
      }, 1000);
    });

    this.chatService.commentCount$.subscribe((data) => {
      this.updatedCommentCount.push(data);

      setTimeout(() => {
        this.updatedCommentCount = this.updatedCommentCount.filter(
          (v, i, a) => i === a.findIndex((t) => t.id === v.id)
        );
        this.AllFeeds.forEach((val) => {
          if (this.updatedCommentCount.length > 0) {
            this.updatedCommentCount.forEach((comment) => {
              if (val.id === comment.activityFeed) {
                if (comment.flag) {
                  if (comment.flag) {
                    //val.isCommentFlagged = comment.isFlaggedBy;
                  }
                } else {
                  if (comment.delete) {
                    val.commentCount = comment.updatedCommentCount;
                  } else {
                    val.commentCount = comment.updatedCommentCount;
                  }
                }
              }
            });
          }
        });
        this.updatedCommentCount = [];
      }, 1000);
    });

    setTimeout(() => {
      //this._feed.getAllFeeds();
    }, 1000);

    this.postFilter.currentMessage.subscribe((res) => {
      this.postFilterOption = res;
    });

    //block server calls - set a variable to true if user clicked logout button, then we restrict all server calls;
    this.chatService.eventEmit$.subscribe((data) => {
      if (data.postType) {
        this.getPosts(data.postType);
      }
    });

    $(".note-editable hr").remove();

    $(document).on(".note-editable hr", function () {
      this.remove();
    });
    // Right side container Overlap with footer Fix

    $(window).on("scroll click", function (event) {
      var scroll_out = $(document).height() - $(window).height();
      var scroll = $(window).scrollTop();
      var doc_height = $(document).height();
      var expScroll = scroll_out - 400;
      var val = scroll - expScroll;
      if (doc_height > 1600) {
        $("#rightside_container").css("position", "fixed");
        if (scroll >= expScroll) {
          $("#rightside_container").css("top", -(val - 108));
        } else if (val > 0) {
          $("#rightside_container").css("top", val + 108);
        } else {
          $("#rightside_container").css("top", 108);
        }
      } else {
        $("#rightside_container").css("position", "initial");
      }
    });

    this.category = "post";
    this.post = this.fb.group({
      title: ["", Validators.compose([Validators.required])],
      content: [""],
      type: [this.category],
    });

    this.editPost = this.fb.group({
      title: ["", Validators.compose([Validators.required])],
      content: [""],
    });

    this.events = this.fb.group({
      startDate: ["", Validators.compose([Validators.required])],
      endDate: ["", Validators.compose([Validators.required])],
      startTime: ["", Validators.compose([Validators.required])],
      endTime: ["", Validators.compose([Validators.required])],
      title: ["", Validators.compose([Validators.required])],
      eventDescription: [""],
      eventGroups: [""],
    });

    this.eventsEditForm = this.fb.group({
      startDate: ["", Validators.compose([Validators.required])],
      endDate: ["", Validators.compose([Validators.required])],
      startTime: ["", Validators.compose([Validators.required])],
      endTime: ["", Validators.compose([Validators.required])],
      title: ["", Validators.compose([Validators.required])],
      eventDescription: [""],
      eventGroups: [""],
    });

    this.maintananceForm = this.fb.group({
      //category          : ['', Validators.compose([Validators.required])],
      title: ["", Validators.compose([Validators.required])],
      description: [""],
      makePublic: [""],
      permissionToEnter: [""],
    });

    this.maintananceFormEdit = this.fb.group({
      //category          : ['', Validators.compose([Validators.required])],
      title: ["", Validators.compose([Validators.required])],
      description: [""],
      makePublic: [""],
      permissionToEnter: [""],
    });

    // Building alert form control declaration which will be later used to fetch input values when form is submitted
    this.buildingAlertsForm = this.fb.group({
      expirationDate: ["", [Validators.required]],
      subject: ["", [Validators.required]],
      message: [""],
      singleBuildingId: [""],
    });

    this.selectedCategory = "Select Category";

    var dateToday: any = new Date();
    $(document).ready(function () {
      $("#date_pick").datepicker({
        minDate: 1,
        onSelect: (dateText, inst) => {
          //this.buildingAlertsForm.controls['expirationDate'].setValue(dateText);
        },
      });
      jQuery.browser = {};
      (function () {
        jQuery.browser.msie = false;
        jQuery.browser.version = 0;
        if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
          jQuery.browser.msie = true;
          jQuery.browser.version = RegExp.$1;
        }
      })();
    });

    /**
     * get all post information
     */
    // if (this.isManager != 'true') {
    //   this.userService.isManagerExists(this.userBuildingId).subscribe(
    //     (building) => {
    //       //console.log('Is Building Manager Exists : ', building);
    //       var buildingManager = building.building[0].buildingManager;
    //       var resident = building.building[0].resident;
    //       if (_.isEmpty(buildingManager) || _.isUndefined(buildingManager)) {
    //         this.isBuildingHasBuildingManager = false;
    //       } else {
    //         this.isBuildingHasBuildingManager = true;
    //       }
    //     }
    //   );
    // }

    if (this.isManager !== "true") {
      this.userService.isManagerExists(this.userBuildingId).subscribe(
        (building: any) => {
          // Log the building data for debugging purposes
          console.log("Is Building Manager Exists: ", building);

          const buildingManager =
            building &&
            building.building &&
            building.building[0] &&
            building.building[0].buildingManager;
          const resident =
            building &&
            building.building &&
            building.building[0] &&
            building.building[0].resident;

          // Check if the buildingManager is either undefined or null
          if (!buildingManager) {
            this.isBuildingHasBuildingManager = false;
          } else {
            this.isBuildingHasBuildingManager = true;
          }
        },
        (error) => {
          // Handle the error case if the API call fails
          console.error("Error fetching building manager data:", error);
        }
      );
    }

    //--------------------------------------

    /*this.ngZone.runOutsideAngular(() => {
      this.timer = Observable.timer(500, 20000)
        .subscribe(i => this.ngZone.run(() => {*/
    /*if(_.isUndefined(this.id) || _.isEmpty(this.id)){
      this.router.navigate(['/']);
    }*/
    /*}));
});*/

    this.ngZone.run(() => {
      var buildingIds = this.userBuildingId.split(",");
      this.buildingService
        .getAllBuildingsByUser(buildingIds)
        .subscribe((buildings) => {
          if (buildings.success) {
            this.Activities = buildings.data;
            this.allBuildingsInfo = buildings.data;
            this.buildingList = buildings.data;
            this.ActivityLength = buildings.data.length;
            // console.log("Selected BuildingData", buildings.data[0]);
            this.selectedBuildingId = buildings.data[0].id;

            this.getRecentBuildingAlerts(this.selectedBuildingId).then(
              (data: any) => {
                this.buildingAlerts = data.alerts[0].buildingAlerts;
                this.buildingAlertsLength = this.buildingAlerts
                ? this.buildingAlerts.length
                : 0;
              }
            );
            this.residentCount = buildings.data[0].resident.length;

            if (buildings.data[0].buildingImage) {
              const img = buildings.data[0].buildingImage;
              this.selectedbuildingImage = img.split("assets")[1]
                ? this.s3apiUrl + img.split("assets")[1]
                : img.startsWith(this.s3apiUrl) ? img : this.s3apiUrl + img;
            }
            if (buildings.data[0].buildingName) {
              this.filteredBuildingName = buildings.data[0].buildingName;
            } else {
              this.filteredBuildingName = buildings.data[0].formattedAddress;
            }

            this.selectedBuilding = buildings.data[0];
            if(this.selectedBuilding.isMaintenanceActive){
            localStorage.setItem(
              "currentBuildingMaintenanceActive",
              this.selectedBuilding.isMaintenanceActive.toString()
            );
           }

            this._feed
              .getAllTypePost(
                this.id,
                this.skip,
                this.limit,
                this.selectedBuildingId,
                false,
                this.typePost
              )
              .subscribe((res) => {
                this.feedArrayLength = res.length;
                this.AllFeeds = res;
                setTimeout(() => {
                  this.userService.getUserById(this.id).subscribe((x) => {
                    if (!x.user.isTour) {
                      this.displayTourGuide(this.id);
                    }
                  });
                }, 1);
                $(document).ready(function () {
                  setTimeout(() => {
                    $(".feed_posted_text p span").each(function () {
                      var fS = $(this).css("font-size");
                      $(this).css("line-height", fS);
                    });
                  }, 4000);
                });
              });
          }
        });

      this.eventService.getAllEvents(this.id).subscribe((res) => {
        if (res) {
          this.attendingUsers = res;
        }
      });
    });

    // ---------------  groups ------------------------

    this._groupService.getAllGroups().subscribe((res) => {
      ////console.log(res);
      res.forEach((building) => {
        building.allGroups.forEach((group) => {
          this.groupList.push(group);
        });
      });
      console.log(this.groupList);
      this.groupList = this.groupList.filter(
        (v, i, a) => i === a.findIndex((t) => t.id === v.id)
      );
      //this.groupList = res;
    });

    //--------------- manager check -------------------
    this.userInfo.checkForBuildingManager(this.id);
    this.userInfo.isManager.subscribe((res: any) => {
      this.isManagerStatus = res;
      this.isBuildingHasBuildingManager = res;
    });

    //-------------------------------------------------

    this.buildingService
      .getAllBuildingsByUserId(this.id)
      .subscribe((buildings) => {
        //console.log(buildings.data[0].building);
        if (buildings.success) {
          this.myBuildings = buildings.data[0].building;
          if (this.myBuildings.length <= 1) {
            this.allBuildings.push(this.myBuildings[0].id);
            this.singleBuilding = this.myBuildings[0];
          } else {
            for (let building of this.myBuildings) {
              this.allBuildings.push(building.id);
            }
          }
          this.myBuildingsLength =
            this.myBuildings.length > 1 ? this.myBuildings.length : 1;
          //console.log('All Buildings : ', this.myBuildingsLength);
        }
      });

    // Building alert form set error flags in ngOnInit so that as and when the field value is typed or changes
    // the error messages are displayed on the fly
    if (
      this.buildingAlertsForm.get("expirationDate").invalid &&
      this.buildingAlertsForm.get("expirationDate").touched
    ) {
      this.expiryDateInvalid = true;
    }

    if (
      this.buildingAlertsForm.get("subject").invalid &&
      this.buildingAlertsForm.get("subject").touched
    ) {
      this.subjectInvalid = true;
    }

    if (
      this.buildingAlertsForm.get("message").invalid &&
      this.buildingAlertsForm.get("message").touched
    ) {
      this.messageInvalid = true;
    }

    /*
     Lazy load post
     Check if the scroll top has reach 0.8 times the document height. If yes start lazy loading activity feed,
     else do nothing. Wait for the next scroll
      */
    var that = this;
    $(document).on("scroll", function () {
      //console.log('that.ifRequestSent', that.ifRequestSent, that.skip, that.totalFeedCount);
      // Do not delete above console, keep it for debugging till we finalize to production
      if (!that.ifRequestSent) {
        that.winHeight = ($(document).height() - $(window).height()) * 0.8;
        //console.log('$(window).scrollTop()', $(window).scrollTop(), 'winHeight', that.winHeight);
        // Do not delete above console, keep it for debugging till we finalize to production
        if ($(window).scrollTop() >= that.winHeight) {
          that.ifRequestSent = true;
          that._feed
            .getTotalFeedCountByBuildingId(that.selectedBuildingId)
            .subscribe((buildings) => {
              if (buildings.status) {
                // for(let build of buildings.count) {
                //   if(build.buildingId === that.selectedBuildingId) {
                that.totalFeedCount = buildings.count;
                //}
                //}

                setTimeout(() => {
                  // Check if records to skip is less than total feed count (totalFeedCount), keep fetching next 5 records if skip
                  console.log(
                    "that.totalFeedCount",
                    that.totalFeedCount,
                    "that.winHeight",
                    that.winHeight,
                    "that.skip + that.skip%5",
                    that.skip + (that.skip % 5)
                  );
                  if (that.totalFeedCount > 5) {
                    that.nextFeedLoading = true;
                    setTimeout(() => {
                      that.skip = that.AllFeeds.length;
                      if (that.skip <= that.totalFeedCount) {
                        that.limit += 5;
                        if (that.skip > that.limit) {
                          that.limit = that.limit + (that.skip - 5);
                        }
                        //  if((that.skip%5) > 5){
                        //     that.skip = that.skip - that.skip%5;
                        //  }
                      }
                      // if (that.skip <= that.totalFeedCount) {
                      //   that.limit += 5;
                      //   if((that.skip + that.skip%5) <= that.totalFeedCount){
                      //     that.skip += 5;
                      //   }else {
                      //     that.skip = that.totalFeedCount - 5;
                      //   }
                      // }else {
                      //   that.limit = that.totalFeedCount;
                      //   if((that.skip + that.skip%5) <= that.totalFeedCount){
                      //     that.skip = that.totalFeedCount - 5;
                      //   }
                      // }

                      //==========================================================
                      // Init load next 5 activity feeds
                      that.tempFeeds = [];
                      that.ifRequestSent = true;
                      that._feed
                        .getAllTypePost(
                          that.id,
                          that.skip,
                          that.limit,
                          that.selectedBuildingId,
                          false,
                          that.typePost
                        )
                        .subscribe((res) => {
                          console.log(
                            res,
                            "============================ feeeeeds"
                          );
                          that.feedArrayLength = res.length;
                          that.tempFeeds = res;
                          that.AllFeeds.push.apply(
                            that.AllFeeds,
                            that.tempFeeds
                          );
                          setTimeout(() => {
                            that.nextFeedLoading = false;
                            that.ifRequestSent = false;
                          }, 1000);
                        });
                      //==========================================================
                    }, 2000);
                  }
                }, 1000);
              }
            });
          // Set timeout before loading starts to get totalFeedCount value
        }
      }
    });

    /**
     * @param :: updatedPosts Array field
     * If any activity happens to the post (upvote, comment, reply..) then this set of code will trigger once
     * and get the updated post and store it in the array updatedPosts
     */

    this.percentageSecrvice.currentMessage.subscribe((res: any) => {
      if (res.feedType == "maintenance") {
        this.maintanance.getMaintananceById(res.id, false).subscribe((data) => {
          if (
            this.updatedPosts.filter((item) => item.id == data.id).length == 0
          ) {
            this.updatedPosts.push(data);
          } else {
            this.updatedPosts = this.updatedPosts.map(function (item) {
              return item.id == data.id ? data : item;
            });
          }
        });
      } else if (res.feedType == "events") {
        this.eventService.getEventsById(res.id, false).subscribe((data) => {
          if (
            this.updatedPosts.filter((item) => item.id == data.id).length == 0
          ) {
            this.updatedPosts.push(data);
          } else {
            this.updatedPosts = this.updatedPosts.map(function (item) {
              return item.id == data.id ? data : item;
            });
          }
        });
      } else if (
        res.feedType == "post" ||
        res.feedType == "recommendation" ||
        res.feedType == "marketplace" ||
        res.feedType == "group"
      ) {
        this._feed.getPostById(res.id, false).subscribe((data) => {
          if (
            this.updatedPosts.filter((item) => item.id == data.id).length == 0
          ) {
            this.updatedPosts.push(data);
          } else {
            this.updatedPosts = this.updatedPosts.map(function (item) {
              return item.id == data.id ? data : item;
            });
          }
        });
      }
    });
  }

  postToolbarToggle(element) {
    $(element).find(".note-toolbar").toggle();
    //console.log(element)
  }

  feedShareOnMail(feed) {
    this.chatService.eventEmit$.emit({ feedShareOnMail: true, feed: feed });
  }

  getPosts(type) {
    this.skip = 0;
    this.limit = 5;
    this.typePost = type;
    this.totalFeedCount = 0;
    this._feed
      .getAllTypePost(
        this.id,
        this.skip,
        this.limit,
        this.selectedBuildingId,
        false,
        type
      )
      .subscribe((res) => {
        this.feedArrayLength = res.length;
        this.AllFeeds = res;
      });
  }

  feedUpdate(feed) {
    this.twitterContent = true;
    this.AllFeeds.forEach((val) => {
      if (val.id === feed.id) {
        val.votes = feed.votes;
        val.isFlagged = feed.isFlagged;
        val.isCommentFlagged = feed.isCommentFlagged;
        val.isReplyFlagged = feed.isReplyFlagged;
        val.title = feed.title;

        if (feed.image) {
          val.image = feed.image;
        }

        if (feed.type === "events") {
          val.startDate = feed.startDate;
          val.startTime = feed.startTime;
          val.endDate = feed.endDate;
          val.endTime = feed.endTime;
          val.eventDescription = feed.eventDescription;
          val.attendees = feed.attendees;
        } else if (feed.type === "maintenance") {
          val.category = feed.category;
          val.description = feed.description;
          val.makePublic = feed.makePublic;
          val.status = feed.status;
          val.permissionToEnter = feed.permissionToEnter;
        } else {
          val.content = feed.content;
        }
      }
    });
  }

  feedImageUploadfiles(files, el) {
    //console.log(files);
  }

  showAllFormBuildings1(buildingListManager) {
    $(buildingListManager).find(".dropdown-content").toggleClass("show");
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.userInfo.getUserInfo();
    }, 3000);

    $(document).on("hide.bs.modal", "#addbuildingmodal", function () {
      this.expiryDateInvalid = false;
      this.subjectInvalid = false;
      this.messageInvalid = false;
      $("div.checkbox_inputs")
        .find('input[type="checkbox"]')
        .each(function (index, ele) {
          //console.log($(this));
          $(this).prop("checked", false);
        });
    });
    var that = this;
    $("#create_event_modal").on("hide.bs.modal", function () {
      that.groupArray = [];
      that.groupResult = [];
      that.groupNames = [];
      that.Names = "";
      that.file = null;
      that.tempPath = null;
      $("div.checkbox_inputs")
        .find('input[type="checkbox"]')
        .each(function (index, ele) {
          console.log("is Checked valv", $(this).prop("checked"));
          $(this).prop("checked", false);
        });
    });

    $("#edit_maintanence_modal").on("hide.bs.modal", function () {
      console.log("eeeee.e.e.e.e.ee.e.e.");
      that.file = null;
      that.tempPath = null;
    });

    $(".fr-toolbar").css({ display: "none" });
    $(this.tabs)
      .find(".tabs_headermenu li")
      .on("click", function () {
        //console.log('clicked');
        var $panel = $(this.tabs).closest(".tab-panels");
        $panel.find(".tabs_headermenu li.active").removeClass("active");
        $(this.tabs).addClass("active");
      });

    $(document).ready(function () {
      var dateNow: any = new Date();
      //console.log(this.groupList);
      $(".date").datepicker({
        minDate: 1,
      });
      jQuery.browser = {};
      (function () {
        jQuery.browser.msie = false;
        jQuery.browser.version = 0;
        if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
          jQuery.browser.msie = true;
          jQuery.browser.version = RegExp.$1;
        }
      })();

      $(".time").timepicker({ timeFormat: "h:mm p" });
      //var valset =$.getMentions();
      // $.getMentions().then(data=>{
      //   console.log(data, "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
      // })

      // setTimeout(() => {

      that.getUsers().then((users: any) => {
        that.users = users;

        $("#summernote").summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
          },

          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      });
      //}, 2000);

      $(".note-insert")
        .find("button")
        .on("click", function () {
          $(".note-image-input").reset();
        });
      $(".note-editor .note-editable").html(
        '<p data-placeholder="Share	with others	in your	building" ></p>'
      );
    });
  }

  showContent(event, e) {
    $(event).find("div.showmoredrp").toggle();
    //  $.getScript('//cdnjs.cloudflare.com/ajax/libs/summernote/0.5.1/summernote.min.js',function(){
    //     $('#summernoteEdit').summernote();
    //  })
    //e.stopPropagation();
  }

  postType(type, event, parentRef) {
    if (
      this.selectedBuilding.isMaintenanceActive == false &&
      type == "maintanance"
    ) {
      return false; // explicitly don't let them enable maintenance
    }

    $(".note-hint-popover").css("display", "none");

    var that = this;
    this.titleError = null;
    this.contentError = null;
    this.startDateError = null;
    this.endTimeError = null;
    this.eventTitleError = null;
    this.eventDescriptionError = null;
    this.startTimeError = null;
    this.endDateError = null;
    this.contentEmpty = null;
    this.buildArray = [];
    this.file = null;
    $(parentRef).find('input[type="checkbox"]').prop("checked", false);
    //console.log(parentRef);
    $(parentRef).find(".tabs_headermenu li.active").removeClass("active");
    $(parentRef).find(event).addClass("active");
    var panelToShow = $(event).attr("rel");
    //$(parentRef).find('.panel.active').hide(showNextPanel);
    $(parentRef).find(".panel.active").removeClass("active");
    $(parentRef)
      .find("#" + panelToShow)
      .addClass("active");

    this.category = type;
    this.buildArray.pop();
    this.status = false;

    if (type == "recommendation") {
      var ele = $(parentRef).find("#panel4 .note-editor");
      if (ele.length === 0) {
        $("#" + type).summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            //setTimeout(function () {
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
            // }, 10);
          },

          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      }

      $(".note-editor .note-editable").html(
        '<p data-placeholder="Share	a	recommendation, a review or a link" ></p>'
      );
    } else if (type == "marketplace") {
      var ele = $(parentRef).find("#panel5 .note-editor");
      if (ele.length === 0) {
        $("#" + type).summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            //setTimeout(function () {
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
            // }, 10);
          },
          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      }

      $(".note-editor .note-editable").html(
        '<p data-placeholder="Describe the item	available	or desired"></p>'
      );
    } else if (type == "events") {
      var ele = $(parentRef).find("#panel2 .note-editor");
      if (ele.length === 0) {
        $("#event_description").summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            // setTimeout(function () {
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
            //}, 10);
          },

          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      }

      $(".note-editor .note-editable").html(
        '<p data-placeholder="Write something..."></p>'
      );
    } else if (type == "maintanance") {
      //console.log(type);
      var ele = $(parentRef).find("#panel3 .note-editor");
      if (ele.length === 0) {
        $("#maintanence_desc").summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            //setTimeout(function () {
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
            //}, 10);
          },

          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      }

      $(".note-editor .note-editable").html(
        '<p data-placeholder="Write something..."></p>'
      );
    } else if (type == "post") {
      $(".note-editor .note-editable").html(
        '<p data-placeholder="Share	with others in your building"></p>'
      );
    }
    this.buildingArray = [];
    this.buildingNames = [];
  }

  clickedItem(value, event) {
    //console.log(value, event);
    this.groupArray = [];
    this.groupNames = [];
    this.tempArray = [];
    $(".events_group_dropdown")
      .find('input[type="checkbox"]')
      .prop("checked", false);
    if (event === true) {
      this.buildArray.push(value.id);
      this.buildingNames.push(
        value.buildingName
          ? value.buildingName
          : value.formattedAddress.split(",")[0]
      );
    } else {
      const index = this.buildArray.indexOf(value.id);
      if (index !== -1) {
        this.buildArray.splice(index, 1);
        this.buildingNames.splice(index, 1);
      }
    }
    this.names = this.buildingNames.toString();

    this.groupList.forEach((value) => {
      value.buildings.forEach((build) => {
        if (this.buildArray.indexOf(build.id) >= 0) {
          this.tempArray.push(value);
        }
      });
    });

    this.tempArray = this.tempArray.filter(
      (v, i, a) => i === a.findIndex((t) => t.id === v.id)
    );
  }

  postData(value, valid, formType) {
    let postcontent;
    this.titleError = "Title is required";
    this.contentError = "Content is required";
    this.titleSpaceError = "Special characters not allowed";
    let titleTrim = "";
    if (this.post.get("title").value) {
      titleTrim = this.post.get("title").value.trim();
    }

    if (titleTrim == "") {
      this.titleSpaceError = "Please enter valid title";
    } else {
      this.titleSpaceError = null;
    }

    if (this.category == "post") {
      postcontent = $("#summernote").summernote("code");
    } else if (this.category == "marketplace") {
      postcontent = $("#marketplace").summernote("code");
    } else if (this.category == "recommendation") {
      postcontent = $("#recommendation").summernote("code");
    }

    //console.log(postcontent, formType ,'-----content check for particular type');
    let textContent = $(formType).find(".note-editable").text().trim();
    if (textContent == "") {
      // valid = false;
      this.post.get("content").patchValue("");
    } else {
      // valid = true;
      this.post.get("content").patchValue(postcontent);
    }

    if (this.post.get("title").valid && titleTrim != "") {
      this.mentionedUsers(postcontent).then((mentionedUsers) => {
        value.mentionedUsers = mentionedUsers;
        this.isPostSuccess = true;
        value.type = this.category;
        value.builds = this.buildArray;
        value.content = postcontent;
        value.file = this.file;
        value.ratingCount = this.ratingcount;
        //console.log(value);
        this.titleError = null;
        this.contentError = null;
        this.titleSpaceError = null;
        this.post.reset();
        $("input.post-title").val("");
        $("div.note-editable p").empty();
        $("div.note-editable").empty();
        $("input[type=file]").val("");
        this.buildArray = [];

        if (this.category === "recommendation") {
          $(".note-editor .note-editable").html(
            '<p data-placeholder="Share	a	recommendation, a review or a link" ></p>'
          );
        } else if (this.category === "marketplace") {
          $(".note-editor .note-editable").html(
            '<p data-placeholder="Describe the item	available	or desired" ></p>'
          );
        } else if (this.category === "post") {
          $(".note-editor .note-editable").html(
            '<p data-placeholder="Share	with others in your building" ></p>'
          );
        }

        this.file = null;
        this.fileName = null;
        this.buildingArray = [];
        this.buildingNames = [];
        $('input[type="checkbox"]').prop("checked", false);
        let temp = value; //after
        this.postPerception(temp);
        this._http.postActivity(value).subscribe(
          async (data) => {
            console.log(data);
            //before---
            // let temp = value;
            // temp.id = data.id;
            // this.postPerception(temp);
            this.tempPostData.id = data.id;
            // await this.updateSavedPostInList();
            console.log(
              data,
              "sssssssss--s--s-s-s-s-s-s-s-s-s--s-s-s-s",
              this.AllFeeds,
              this.tempPostData
            );
            setTimeout(() => {
              console.log(data.id, "post");
              this._feed.getPostById(data.id).subscribe((feed) => {
                this.isPostSuccess = false;
              });
            }, 2000);
            this.scrollToFeed();
            this.ratingcount = 0;
            this.tempPostData = {};
          },
          (error) => {
            this.showLoading = false;
            this.isPostSuccess = false;
            this.tempPostData = {};
            //window.location.href = '/';
          }
        );
      });
    }
  }
  ratingComponentClick(event) {
    this.ratingcount = event.rating;
  }

  hidePostEditForm(event, iscancel = null) {
    if (iscancel === "cancel") {
      this.file = null;
      this.tempPath = null;
      this.showLoading = false;
    }

    $(event).find("span.postEditForm").hide();
    $(event).parents(".single_feed_wrap").find("span.activity_content").show();
    $(event).parents(".single_feed_wrap").find("span.post_title").show();
  }

  postPerception(data) {
    var postData = data;
    this.uuid = UUID.UUID();
    postData.buildingId = [];

    if (postData.builds.length === 0) {
      postData.buildingId = [{ id: this.selectedBuildingId }];
    } else {
      postData.builds.forEach((id) => {
        postData.buildingId.push({ id: id });
      });
    }

    postData.residentId = this.userProfile;

    postData.isCommentFlagged = [];
    postData.isReplyFlagged = [];
    postData.isFlagged = [];
    postData.eventGroups = [];
    postData.attendees = [];
    postData.members = [];
    postData.image = null;

    postData.replyCount = 0;
    postData.commentCount = 0;
    postData.votes = 0;
    postData.createdAt = Date();
    postData.uuid = this.uuid;
    postData.id = data.id;

    if (postData.type === "events") {
      postData.attendees = [];
    }

    if (postData.type === "maintenance") {
      postData.status = "NEW";
    }

    this.tempPostData = postData;
  }

  async updateSavedPostInList() {
    if (this.tempPostData && Object.keys(this.tempPostData).length > 0) {
      this.AllFeeds.unshift(this.tempPostData);
      this.showLoading = true;
    } else {
      console.warn("tempPostData is empty, skipping update.");
    }
  }
  getFeed(feed, event) {
    var that = this;
    if (feed.id) {
      $("span.postEditForm").hide();
      $(event).find("span.postEditForm").show();
      $(event)
        .parents(".single_feed_wrap")
        .find("span.activity_content")
        .hide();
      $(event).parents(".single_feed_wrap").find("span.post_title").hide();

      var ele = $(event).find(".note-editor");

      if (ele.length === 0) {
        $(event)
          .find("#summernoteEdit")
          .summernote({
            onpaste: function (e) {
              var bufferText = (
                (e.originalEvent || e).clipboardData || window.captureEvents
              ).getData("Text");
              e.preventDefault();
              //setTimeout(function () {
              document.execCommand("insertText", false, bufferText);
              $(this).parent().siblings(".summernote").destroy();
              // }, 10);
            },
            toolbar: [
              ["style", ["bold", "italic", "underline"]],
              ["fontname", ["fontname"]],
              ["fontsize", ["fontsize"]],
              ["color", ["color"]],
              ["para", ["paragraph"]],
              ["insert", ["picture"]],
            ],

            hint: {
              mentions: that.users,
              match: /\B@(\w*)$/,
              search: function (keyword, callback) {
                callback(
                  $.grep(this.mentions, function (item) {
                    return item.name.indexOf(keyword) == 0;
                  })
                );
              },
              template: function (item) {
                return item.name;
              },
              content: function (item) {
                return $(
                  '<a href="javascript:void(0);" class="mentionned mentioned-' +
                    item.id +
                    '" data.email=' +
                    item.email +
                    " data.id=" +
                    item.id +
                    ">@" +
                    item.name +
                    "</a>"
                )[0];
              },
            },
          });
      }

      $("#summernoteEdit").summernote("code");
      this.editPost.get("content").patchValue(feed.content);
      this.editPost.get("title").patchValue(feed.title);
      this.ActivityId = feed.id;
      $(event).find("#summernoteEdit").summernote("code", feed.content);
    }
  }

  toggleRightWidget() {
    $("#menu_onclick").animate({
      //width:0,
      //"opacity": 0,
      left: "-110%",
      transition: "all 0.2s",
      //"display":"none"
    });
    $(".toggleRightWidget").hide();
    $(".toggleLeftWidget").show();
  }

  toggleLeftWidget() {
    $("#menu_onclick").animate({
      //width:250,
      //"opacity": 1,
      left: "0%",
      transition: "all 0.1s",
      //"display":"initial"
    });
    $(".toggleRightWidget").show();
    $(".toggleLeftWidget").hide();
  }

  postSave(value, valid, specificPost) {
    let title = this.editPost.get("title").value.trim();

    if (title === "") {
      this.editPost.get("title").patchValue(title);
    }

    this.titleError = "Title is required";
    this.contentError = "Content is required";
    this.titleSpaceError = "Special characters not allowed";

    const changedData = $(specificPost).find("div.note-editable").text().trim();
    let data = changedData.replace("<p></p>", "");
    if (data === "<p><br></p>") {
      this.editPost.get("content").patchValue("");
    } else if (data.length === 0) {
      this.editPost.get("content").patchValue("");
    } else {
      this.editPost.get("content").patchValue(data);
    }

    //console.log(this.ActivityId);

    value.content = $(specificPost).find("div.note-editable").html();
    value.file = this.file;

    this.mentionedUsers(value.content).then((list) => {
      console.log(list, "gg");
      value.mentionedUsers = list;

      if (valid && title !== "") {
        this.isEditPostSuccess = true;
        this._feed
          .updatePost(value, this.ActivityId, this.fileChanged)
          .subscribe(
            (res) => {
              this.twitterContent = false;
              setTimeout(() => {
                this._feed.getPostById(res.id).subscribe((feed) => {
                  this.isEditPostSuccess = false;
                });
              }, 2000);
              //==============================

              this.successMessage = res.message;
              if (res) {
                // this._feed.getPost().subscribe((res) => {
                // this.Activities = res;
                //   this.allBuildingsInfo = res;
                // });

                this.titleError = null;
                this.contentError = null;
                this.titleSpaceError = null;
                this.file = null;
                this.fileName = null;
              }
            },
            (error) => {}
          );
        //   this._feed.getPost().subscribe((res) => {
        //     this.Activities = res;
        //     this.allBuildingsInfo = res;
        //     //console.log(res);

        // })
      }
    });
  }

  deletePost(id) {
    //const data =  id.innerHTML;
    if (id) {
      this.AllFeeds = this.AllFeeds.filter((item) => item.id !== id);

      this._feed.deletePost(id).subscribe(
        (res: any) => {
          this.successMessage = res.message;
        },
        (error) => {
          //window.location.href = '/';
        }
      );
    }
  }

  showPostToolbar() {}

  buildingFilter(
    value,
    index,
    event,
    buildingNameSelected,
    imageOnDrop,
    residentCount
  ) {
    //console.log("PostComponent.buildingFilter", value);
    //console.log(imageOnDrop, residentCount);
    this.ifRequestSent = false;
    this.buildingFilterStore.push(value.id);
    this.residentCount = residentCount;
    this.filteredBuildingName = buildingNameSelected.innerHTML;
    this.buildingIndex = index;
    this.selectedBuildingId = value.id;
    this.selectedBuilding = value;
    if (
      typeof value.isMaintenanceActive === "undefined" ||
      value.isMaintenanceActive === null
    ) {
      value.isMaintenanceActive = true;
    }
    localStorage.setItem(
      "currentBuildingMaintenanceActive",
      (!!value.isMaintenanceActive).toString()
    );
    let buildingImage = null;
    this.Activities = this.allBuildingsInfo;
    var tempBuildings = [];
    for (let building of this.Activities) {
      if (building.id !== this.selectedBuildingId) {
        tempBuildings.push(building);
      }
    }
    this.Activities = tempBuildings;

    //console.log('value.buildingImage', value.buildingImage);
    if (value.buildingImage) {
      const img = value.buildingImage;
      this.selectedbuildingImage = img.split("assets")[1]
        ? environment.s3BucketApi + img.split("assets")[1]
        : img.startsWith(environment.s3BucketApi) ? img : environment.s3BucketApi + img;
    } else {
      this.selectedbuildingImage = null;
    }
    this.skip = 0;
    this.limit = 5;
    this.totalFeedCount = 0;

    this._feed
      .getAllTypePost(
        this.id,
        this.skip,
        this.limit,
        this.selectedBuildingId,
        false,
        this.typePost
      )
      .subscribe((res) => {
        this.feedArrayLength = res.length;
        this.AllFeeds = res;
      });

    this.getRecentBuildingAlerts(this.selectedBuildingId).then((data: any) => {
      this.buildingAlerts = data.alerts[0].buildingAlerts;
      this.buildingAlertsLength = this.buildingAlerts
        ? this.buildingAlerts.length
        : 0;
    });

    //console.log('filtered building', value);
  }

  flagPostToggle(activityId, event, ele, isManager, flagType) {
    console.log(isManager, flagType);
    //$(ele).find('span').toggle();
    if (activityId.id) {
      var data = {
        id: activityId.id,
        type: activityId.type,
        isManager: isManager,
        flagType: flagType,
      };

      this.flagPostIDList = [];
      this._http.flagPostById(data, this.id).subscribe((res) => {
        //console.log('Flagged ppOSTV  : ', res);
        //console.log('User building ID : ', this.userBuildingId.split(','));
        var buildingIDs = this.userBuildingId.split(",");
        // this._http.getFlaggedActivityFeedByUserBuilding(buildingIDs, this.id).subscribe(
        //   (feeds) => {
        //     for(let feed of feeds.feeds){
        //       if(feed.isFlagged.length > 0){
        //         this.flagPostIDList.push(feed.id);
        //       }
        //     }
        //     //console.log('Flagged Posts : ', feeds);
        //   }
        // );
      });
    }
  }

  openChat(user) {
    this.chatService.open(user);
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.timer) {
      this.timer.unsubscribe();
    }
  }

  @HostListener("keyup", ["$event"])
  inputChanged(event) {
    $(event.target).find("p").removeAttr("data-placeholder");
  }

  groupDropDown(dropMenu, drop = null) {
    if ($(dropMenu).hasClass("show")) {
      $(dropMenu).removeClass("show");
    } else {
      $(dropMenu).find(".category_drp").toggleClass("show");

      setTimeout(() => {
        if (!$(dropMenu).hasClass("show")) {
          $(dropMenu).toggleClass("show");
        }
      }, 200);
    }
  }

  showAllFormBuildings(buildingListManager) {
    $(buildingListManager).find(".dropdown-content").toggleClass("show");
  }

  groups(event, group, name) {
    this.Names = "";
    if (event == true) {
      this.groupArray.push(group);
      this.groupNames.push(name);
      this.groupNameEdit.push(name);
    } else if (event == false) {
      const index = this.groupArray.indexOf(group);
      if (index !== -1) {
        this.groupArray.splice(index, 1);
        this.groupNames.splice(index, 1);
        this.groupNameEdit.splice(index, 1);
      }
    }
    this.editNames = this.groupNameEdit.toString();
    this.groupNames.forEach((name) => {
      this.Names =
        this.Names.length == 0
          ? this.Names + "" + name
          : this.Names + ", " + name;
    });
  }

  eventSubmit(value, valid, form) {
    //console.log(value)
    let eventTitleLength = "";
    if (this.events.get("title").value) {
      eventTitleLength = this.events.get("title").value.trim();
    }
    let postcontent;
    let descriptionValid = false;
    this.startDateError = "Start date is required";
    this.endDateError = "End date is required";
    this.startTimeError = "Start time is required";
    this.endTimeError = "End time is required";
    this.eventTitleError = "Title is required";
    this.eventDescriptionError = "Description is required";
    this.titleSpaceError = "Title is required";
    let titleSpaceValid = false;

    //this.events.get('eventGroups').patchValue(this.groupArray);
    postcontent = $("#event_description").summernote("code");
    console.log(postcontent);
    var eventCode = $(form).find(".note-editable").text().trim();
    if (eventCode == "") {
      this.events.get("eventDescription").patchValue("");
    } else {
      this.events.get("eventDescription").patchValue(postcontent);
    }

    if (eventTitleLength.length == 0) {
      titleSpaceValid = false;
      this.titleSpaceError = "Title is required";
    } else if (eventTitleLength.length > 0) {
      titleSpaceValid = true;
      this.titleSpaceError = null;
    }

    this.mentionedUsers(postcontent).then((mentionedUsers) => {
      if (
        this.events.get("startDate").valid &&
        this.events.get("endDate").valid &&
        this.events.get("startTime").valid &&
        this.events.get("endTime").valid &&
        this.events.get("title").valid &&
        this.dateValidation == true &&
        titleSpaceValid == true
      ) {
        this.isPostSuccess = true;
        this.startDateError = null;
        this.endDateError = null;
        this.startTimeError = null;
        this.endTimeError = null;
        this.eventTitleError = null;
        this.eventDescriptionError = null;
        this.titleSpaceError = null;
        this.events.reset();
        value.type = this.category;
        value.startTime = new Date(value.startDate + " " + value.startTime);
        value.endTime = new Date(value.endDate + " " + value.endTime);
        value.startDateRaw = this.extractRawDate(value.startTime);
        value.endDateRaw = this.extractRawDate(value.endTime);
        value.eventDescription = postcontent;
        value.builds = this.buildArray;
        value.eventGroups = this.groupArray;
        value.file = this.file;
        value.mentionedUsers = mentionedUsers;

        //Clearing form details
        $("div.note-editable p").empty();
        $("div.note-editable").empty();
        $("input[type=file]").val("");
        this.buildArray = [];
        this.file = null;
        this.groupNames = [];
        this.groupArray = [];
        this.fileName = null;
        $('input[type="checkbox"]').prop("checked", false);
        this.buildingArray = [];
        this.buildingNames = [];

        $(".note-editor .note-editable").html(
          '<p data-placeholder="Write something..." ></p>'
        );
        this.postPerception(value);
        this.eventService.postEvent(value).subscribe(
          async (res) => {
            this.tempPostData.id = res.id;
            //await this.updateSavedPostInList();
            // setTimeout(() => {
            this.eventService.getEventsById(res.id).subscribe((res) => {
              this.isPostSuccess = false;
            });
            // }, 2000);
            this.scrollToFeed();
          },
          (error) => {
            //console.log(error);
          }
        );
      }
    });
    this.eventService.getAllEvents(this.id).subscribe((res) => {
      if (res) {
        this.attendingUsers = res;
      }
    });
  }

  padDate10(n) {
    return (n < 10 ? "0" : "") + n.toString();
  }

  padDate100(n) {
    return (n < 100 ? "0" : "") + this.padDate10(n);
  }

  extractRawDate(d) {
    return (
      d.getFullYear() +
      "-" +
      this.padDate10(d.getMonth() + 1) +
      "-" +
      this.padDate10(d.getDate()) +
      "T" +
      this.padDate10(d.getHours()) +
      ":" +
      this.padDate10(d.getMinutes()) +
      ":" +
      this.padDate10(d.getSeconds()) +
      "." +
      this.padDate100(d.getMilliseconds()) +
      "Z"
    );
  }

  eventUpdate(value, valid, form) {
    let postcontent;
    this.startDateError = "Start date is required";
    this.endDateError = "End date is required";
    this.startTimeError = "Start time is required";
    this.endTimeError = "End time is required";
    this.eventTitleError = "Title is required";
    this.eventDescriptionError = "Description is required";
    this.titleSpaceError = "Special characters not allowed";

    postcontent = $("#event_description_edit").summernote("code");
    //console.log(postcontent);
    var eventCode = $(form).find(".note-editable").text().trim();
    if (eventCode == "") {
      this.eventsEditForm.get("eventDescription").patchValue("");
    } else {
      //console.log(postcontent, '....');
      this.eventsEditForm.get("eventDescription").patchValue(postcontent);
    }

    this.mentionedUsers(postcontent).then((mentionedUsers) => {
      if (
        this.eventsEditForm.get("startDate").valid &&
        this.eventsEditForm.get("endDate").valid &&
        this.eventsEditForm.get("startTime").valid &&
        this.eventsEditForm.get("endTime").valid &&
        this.eventsEditForm.get("title").valid &&
        this.dateValidation == true
      ) {
        this.isEditPostSuccess = true;
        //console.log('condition ok', value);
        value.type = this.category;
        value.startTime = new Date(value.startDate + " " + value.startTime);
        value.endTime = new Date(value.endDate + " " + value.endTime);
        value.startDateRaw = this.extractRawDate(value.startTime);
        value.endDateRaw = this.extractRawDate(value.endTime);
        value.eventDescription = postcontent;
        value.builds = this.buildArray;
        value.eventGroups = this.groupArray;
        value.mentionedUsers = mentionedUsers;

        value.file = this.file;
        this.isShowCalendar = false;
        this.eventService.updateEvent(value, this.eventsId).subscribe(
          (res) => {
            this.twitterContent = false;
            //============================

            $(form).find('input[type="checkbox"]').prop("checked", false);
            this.groupArray = [];

            setTimeout(() => {
              this.eventService.getEventsById(res.id).subscribe((feed) => {
                this.isEditPostSuccess = false;
              });
            }, 2000);

            //============================

            this.eventService.getEvents(this.id).subscribe((res) => {
              this.eventList = res;
              //console.log(res);
              this.successMessage = "event updated";
              setTimeout(() => {
                $("#create_event_modal").modal("hide");
                this.successMessage = null;
              }, 2000);
            });

            this.startDateError = null;
            this.endDateError = null;
            this.startTimeError = null;
            this.endTimeError = null;
            this.eventTitleError = null;
            this.eventDescriptionError = null;
            this.titleSpaceError = null;
            this.file = null;
            this.fileName = null;
          },
          (error) => {
            //console.log(error);
          }
        );
      }
    });
  }

  userUpvote(activityId) {
    if (activityId) {
      this._feed.activityLikes(activityId, this.id).subscribe((res) => {});
    }
  }

  deleteEvent(eventId) {
    if (eventId) {
      this.AllFeeds = this.AllFeeds.filter((i) => i.id !== eventId);
      this.eventService.deleteEvent(eventId).subscribe(
        (res) => {
          this.AllFeeds = this.AllFeeds.filter((item) => item.id !== res[0].id);
          this.eventService.getEvents(this.id).subscribe((res) => {
            this.eventList = res;
            this.currentEventLength = res[0].event.length;
          });
        },
        (error) => {
          //console.log(error)
        }
      );
    }
  }

  getEventsToPop(eventModal, eventFormEdit) {
    var that = this;
    if (eventModal) {
      this.groupArray = [];
      this.groupResult = [];
      this.groupNameEdit = [];
      this.editNames = "";
      this.startDateRefEdit = null;
      this.startTimeRefEdit = null;
      this.endDateRefEdit = null;
      this.endTimeRefEdit = null;
      this.GroupStatus = false;
      this.fileName = null;
      this.file = null;

      $(".time1").timepicker({
        template: "modal",
      });
      setTimeout(() => {
        $(".date1").datepicker({
          minDate: 1,
        });
      }, 3000);

      var ele = $(eventFormEdit).find(".note-editor");
      if (ele.length === 0) {
        $(eventFormEdit)
          .find("#event_description_edit")
          .summernote({
            onpaste: function (e) {
              var bufferText = (
                (e.originalEvent || e).clipboardData || window.captureEvents
              ).getData("Text");
              e.preventDefault();
              //setTimeout(function () {
              document.execCommand("insertText", false, bufferText);
              $(this).parent().siblings(".summernote").destroy();
              // }, 10);
            },
            toolbar: [
              ["style", ["bold", "italic", "underline"]],
              ["fontname", ["fontname"]],
              ["fontsize", ["fontsize"]],
              ["color", ["color"]],
              ["para", ["paragraph"]],
              ["insert", ["picture"]],
            ],
            hint: {
              mentions: that.users,
              match: /\B@(\w*)$/,
              search: function (keyword, callback) {
                callback(
                  $.grep(this.mentions, function (item) {
                    return item.name.indexOf(keyword) == 0;
                  })
                );
              },
              template: function (item) {
                return item.name;
              },
              content: function (item) {
                return $(
                  '<a href="javascript:void(0);" class="mentionned mentioned-' +
                    item.id +
                    '" data.email=' +
                    item.email +
                    " data.id=" +
                    item.id +
                    ">@" +
                    item.name +
                    "</a>"
                )[0];
              },
            },
          });
      }

      $("#create_event_modal").modal("show");
      this.modalHideDetect();
      //const id = eventModal.innerHTML;
      this.eventsId = eventModal;
      this.eventService.getEventsById(eventModal, false).subscribe((res) => {
        this.eventToEdit = res;
        res.eventGroups.forEach((val) => {
          this.groupArray.push(val.id);
          this.groupResult.push(val.id);
          this.groupNameEdit.push(val.name);
        });
        // console.log(this.groupArray, "ARRRRRR");
        this.editNames = this.groupNameEdit.toString();

        if (res.image) {
          this.fileName = res.image[0].filename;
        }
        console.log(this.fileName);
        var startDate = new Date(res.startDate)
          .toLocaleDateString("en-US")
          .slice(0, 10);
        var endDate = new Date(res.endDate)
          .toLocaleDateString("en-US")
          .slice(0, 10);
        var startTime = new Date(res.startTime).toLocaleTimeString("en-US");
        var endTime = new Date(res.endTime).toLocaleTimeString("en-US");
        //console.log(startTime, endTime);
        this.eventsEditForm.get("title").patchValue(res.title);
        this.eventsEditForm.get("startDate").patchValue(startDate);
        this.eventsEditForm.get("endDate").patchValue(endDate);
        this.eventsEditForm.get("startTime").patchValue(startTime);
        this.eventsEditForm.get("endTime").patchValue(endTime);
        setTimeout(() => {
          $("#event_description_edit").summernote("code", res.eventDescription);
        }, 2000);
      });
    }
  }

  EventUpvote(eventId, votes) {
    //console.log(votes);
    if (eventId) {
      this.eventsVoteCount = votes;
      this.eventService.eventsLikes(eventId, this.id).subscribe((res) => {
        this.updatedEventVote = res.vote;
        //console.log(this.updatedEventVote, this.eventsVoteCount);
        this.eventService.getEvents(this.id).subscribe((res) => {
          this.eventList = res;
          //console.log(res);
        });
      });
    }
  }

  categorySelect(category) {
    this.selectedCategory = category;
  }

  EditorToggle(form) {
    $(form).find(".note-toolbar").toggle();
  }

  maintananceFormSubmit(value, valid, form, checkbox) {
    //console.log(value)
    let titleLength = this.maintananceForm.get("title").value.trim();
    //console.log(titleLength, titleLength.length, '........');
    this.titleError = "Title is required";
    this.contentError = "Description is required";
    this.contentEmpty = "Space not allowed";
    this.titleSpaceError = "Please enter title";
    let postcontent;
    let descriptionValid = false;
    let selectedCategoryValid = false;
    let titlespaceValid = false;
    if (this.selectedCategory == "Select Category") {
      let selectedCategoryValid = false;
      this.error = "Selected category is required";
    } else {
      selectedCategoryValid = true;
      this.error = null;
    }
    if (titleLength.length == 0) {
      titlespaceValid = false;
      this.titleSpaceError = "Please enter title";
    } else if (titleLength.length > 0) {
      titlespaceValid = true;
      this.titleSpaceError = null;
    }

    postcontent = $("#maintanence_desc").summernote("code");
    var maintenanceCode = $(form).find(".note-editable").text().trim();
    if (maintenanceCode == "") {
      this.maintananceForm.get("description").patchValue("");
    } else {
      this.maintananceForm.get("description").patchValue(postcontent);
    }

    this.mentionedUsers(postcontent).then((mentionedUsers) => {
      if (
        selectedCategoryValid &&
        this.maintananceForm.get("title").valid &&
        titlespaceValid == true
      ) {
        this.isPostSuccess = true;
        this.titleError = null;
        this.contentError = null;
        this.titleSpaceError = null;
        this.maintananceForm.reset();
        //console.log('maiiiiii');
        value.description = postcontent;
        value.category = this.selectedCategory;
        value.builds = this.buildArray;
        value.file = this.file;
        value.type = "maintenance";
        value.mentionedUsers = mentionedUsers;
        if (value.permissionToEnter == "" || value.permissionToEnter == null) {
          value.permissionToEnter = false;
        }

        console.log(value, "jjjjjj-j-j-j-j-j-");

        $("div.note-editable p").empty();
        $("div.note-editable").empty();
        $("input[type=file]").val("");
        $(checkbox).find('input[type="checkbox"]').prop("checked", false);
        this.selectedCategory = "Select Category";
        this.buildArray = [];
        this.file = null;
        this.fileName = null;
        $(".note-editor .note-editable").html(
          '<p data-placeholder="Write something..." ></p>'
        );
        $('input[type="checkbox"]').prop("checked", false);
        this.buildingArray = [];
        this.buildingNames = [];
        this.postPerception(value);
        value.makePublic =
          String(value.makePublic).trim().toLowerCase() === "true";
        this.maintanance.createMaintanance(value, this.id).subscribe((res) => {
          setTimeout(() => {
            this.maintanance.getMaintananceById(res.id).subscribe((feed) => {
              this.isPostSuccess = false;
            });
          }, 2000);
          this.scrollToFeed();
        });
      }
    });
  }

  /**
   * Handles even submit, when Building Alert form is submitted
   * The input values are taken from Form Control declared in ngOnInit
   * This method, first performs validation on the submitted fields, sets various error flags if validation fails
   * If all values passes validation, the values are submitted to the service that connects to the backend
   * and stores values in DB
   * Response: Created alert value as per BuildingAlert Model in Sails
   */
  onBuildingAlertSubmit() {
    this.subjectInvalid = this.buildingAlertsForm.get("subject").invalid;

    this.messageInvalid = this.buildingAlertsForm.get("message").invalid;

    const formData = this.buildingAlertsForm.value;
    const expDate = formData.expirationDate;
    const subject = formData.subject;
    const message = formData.message;
    const building =
      this.selectedBuildings.length > 0
        ? this.selectedBuildings
        : this.allBuildings;

    this.subjectInvalid =
      subject == null || (subject != null && subject.trim().length <= 0);

    // this.messageInvalid = message == null || (message != null && message.trim().length <= 0);

    this.expiryDateInvalid =
      expDate == null ||
      (expDate != null && expDate.toString().trim().length <= 0);

    //console.log('this.expiryDateInvalid : ', this.expiryDateInvalid);
    //console.log('this.messageInvalid : ', this.messageInvalid);
    //console.log('this.subjectInvalid : ', this.subjectInvalid);

    console.log("this.expiryDateInvalid", this.expiryDateInvalid);

    if (
      !this.subjectInvalid &&
      !this.messageInvalid &&
      !this.expiryDateInvalid
    ) {
      const alertData = {
        building: building,
        expirationDate: expDate,
        subject: subject,
        message: message,
        createdBy: this.id,
      };

      this.buildingService
        .saveBuildingAlert(alertData)
        .subscribe((response) => {
          //console.log('Building Alert Saved ? :', response);
          if (response.success) {
            this.buildingAlertsForm.reset();

            this.isCreated = true;
            setTimeout(() => {
              $("button.close").trigger("click");
              this.isCreated = false;
              this.isError = false;
            }, 3000);
            this.scrollToFeed();
          } else {
            this.isCreated = false;
            this.isError = true;
          }
        });
    }
  }

  buildingCheckboxClicked(building, event, index) {
    //console.log(buildingId, 'Building ID');
    //console.log(event.target.checked, 'Event');
    //console.log(index, 'Index');

    if (event.target.checked) {
      this.selectedBuildings.push(building.id);
      this.selectedBuildingNameAlert.push(
        building.buildingName
          ? building.buildingName
          : building.formattedAddress.split(",")[0]
      );
    } else {
      _.forEach(this.selectedBuildings, (val, key) => {
        if (val === building.id) {
          this.selectedBuildings.splice(this.selectedBuildings.indexOf(val), 1);
          this.selectedBuildingNameAlert.splice(
            this.selectedBuildingNameAlert.indexOf(val),
            1
          );
        }
      });
    }
    console.log("buildingsSelected: ", this.selectedBuildingNameAlert);
    this.selectedBuildingAlert = this.selectedBuildingNameAlert.toString();
  }

  deleteMaintanance(mainId) {
    //const data =  mainId.innerHTML;
    if (mainId) {
      this.AllFeeds = this.AllFeeds.filter((i) => i.id !== mainId);
      this.maintanance.deleteMaintanance(mainId).subscribe(
        (res) => {},
        (error) => {
          //console.log(error)
        }
      );
    }
  }

  maintananceStatusUpdate(status, id) {
    //const data =  id.innerHTML;
    if (id) {
      this.maintanance
        .updateMaintananceStatus(status, id)
        .subscribe((res) => {});
    }
  }

  maintananceUpvote(id) {
    if (id) {
      this.maintanance.maintananceLikes(id, this.id).subscribe((res) => {});
    }
  }

  editMaintanance(maintanen, showForm, toolbar) {
    //const data =  maintanen.innerHTML;
    var that = this;
    if (maintanen) {
      this.maintananceId = maintanen;
      this.file = null;
      this.fileName = null;
      var ele = $(toolbar).find(".note-editor");
      if (ele.length === 0) {
        $("#maintanence_desc_edit").summernote({
          onpaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.captureEvents
            ).getData("Text");
            e.preventDefault();
            //setTimeout(function () {
            document.execCommand("insertText", false, bufferText);
            $(this).parent().siblings(".summernote").destroy();
            // }, 10);
          },
          toolbar: [
            ["style", ["bold", "italic", "underline"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["color", ["color"]],
            ["para", ["paragraph"]],
            ["insert", ["picture"]],
          ],
          hint: {
            mentions: that.users,
            match: /\B@(\w*)$/,
            search: function (keyword, callback) {
              callback(
                $.grep(this.mentions, function (item) {
                  return item.name.indexOf(keyword) == 0;
                })
              );
            },
            template: function (item) {
              return item.name;
            },
            content: function (item) {
              return $(
                '<a href="javascript:void(0);" class="mentionned mentioned-' +
                  item.id +
                  '" data.email=' +
                  item.email +
                  " data.id=" +
                  item.id +
                  ">@" +
                  item.name +
                  "</a>"
              )[0];
            },
          },
        });
      }

      this.maintanance.getMaintananceById(maintanen, false).subscribe(
        (res) => {
          this.maintananceFormEdit.get("title").patchValue(res.title);
          this.maintananceFormEdit.get("makePublic").patchValue(res.makePublic);
          this.maintananceFormEdit
            .get("permissionToEnter")
            .patchValue(res.permissionToEnter);
          if (res.image) {
            this.fileName = res.image[0].filename;
          }
          this.selectedCategory = res.category;
          setTimeout(() => {
            $("#maintanence_desc_edit").summernote("code", res.description);
          }, 3000);
        },
        (error) => {}
      );
      $("#edit_maintanence_modal").modal("show");
      this.modalHideDetect();
    }
  }

  maintananceFormUpdate(value, valid, maintanen, maintainEdit) {
    this.titleError = "Title is required";
    this.titleSpaceError = "Special characters not allowed";
    let postcontent;
    let descriptionValid = false;
    let selectedCategoryValid = false;
    if (this.selectedCategory == "Select Category") {
      let selectedCategoryValid = false;
      this.error = "Selected category is required";
    } else {
      selectedCategoryValid = true;
      this.error = null;
    }

    postcontent = $("#maintanence_desc_edit").summernote("code");
    var maintenanceCode = $(maintainEdit).find(".note-editable").text().trim();
    if (maintenanceCode == "") {
      this.contentError = "Description is required";
      this.maintananceForm.get("description").patchValue("");
    } else {
      this.contentError = null;
      this.maintananceForm.get("description").patchValue(postcontent);
    }

    this.mentionedUsers(postcontent).then((mentionedUsers) => {
      if (this.maintananceFormEdit.get("title").valid) {
        this.isEditPostSuccess = true;
        value.description = postcontent;
        value.category = this.selectedCategory;
        value.type = "maintenance";
        value.file = this.file;
        value.mentionedUsers = mentionedUsers;
        this.maintanance
          .updateMaintanance(value, this.maintananceId, this.fileChanged)
          .subscribe(
            (res) => {
              this.twitterContent = false;
              setTimeout(() => {
                this.maintanance
                  .getMaintananceById(res.id)
                  .subscribe((feed) => {
                    this.isEditPostSuccess = false;
                  });
              }, 2000);

              this.successMessage = res.message;
              this.contentError = null;
              this.titleError = null;
              this.titleSpaceError = null;
              this.file = null;
              this.fileName = null;
              $("#edit_maintanence_modal").modal("hide");
              this.successMessage = null;
            },
            (error) => {}
          );
      }
    });
  }

  buildingSelectDrop(dropmenu) {
    $(dropmenu).toggle();
  }

  resetAlertForm() {
    this.buildingAlertsForm.reset();
    this.selectedBuildingAlert = "";
    this.selectedBuildingNameAlert = [];
    this.expiryDateInvalid = false;
    this.subjectInvalid = false;
    this.messageInvalid = false;
    $("div.checkbox_inputs")
      .find('input[type="checkbox"]')
      .each(function (index, ele) {
        $(this).prop("checked", false);
      });
  }

  checkUserHasFlagged(user) {
    if (user.id !== this.id) {
      return true;
    }
  }

  checkUserHasUnflagged(user) {
    if (user.id === this.id) {
      return true;
    }
  }

  calendarTrigger(element) {
    $(element).focus();
  }

  timeTrigger(element, e) {
    $(element).focus();
    e.stopPropagation();
  }

  timeValidation(time1, date1, date2, time2) {
    var startDate = new Date(date1 + " " + time1);
    var endDate = new Date(date2 + " " + time2);
    var startHour = startDate.getTime();
    var endHour = endDate.getTime();

    if (startHour >= endHour) {
      this.dateValidation = false;
      this.dateValidationError =
        "Start date/time must be less than end date/time";
    } else if (startHour < endHour) {
      this.dateValidation = true;
      this.dateValidationError = null;
    }
  }

  eventDownload(
    subject,
    description,
    startDate,
    endDate,
    startTime,
    endTime,
    id
  ) {
    var startDt = new Date(startDate).toLocaleDateString("en-US").slice(0, 10);
    var endDt = new Date(endDate).toLocaleDateString("en-US").slice(0, 10);
    var startTim = new Date(startTime).toLocaleTimeString("en-US");
    var endTim = new Date(endTime).toLocaleTimeString("en-US");
    let users = [];
    let text = jQuery(description).text();

    setTimeout(() => {
      var event = new iCalEvent();
      event.set("uid", 9873647);
      event.set("offset", new Date().getTimezoneOffset());
      event.set("method", "request");
      event.set("attendees", users);
      event.set("start", "2017-12-01T02:00:00-05:00");
      event.set("end", "2017-12-02T02:30:00-05:00");
      event.set("timezone", "US/Central");
      event.set("summary", subject);
      event.set("description", text);
      event.set("location", "Casa");
      // event.set('summary', subject);
      // event.set('description', text);
      event.toFile();

      let data = JSON.stringify(event.event, null, "\t");
      let blob = new Blob([data], { type: "text/calendar" });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    }, 1000);
  }

  attendingUser(id) {
    if (id) {
      this.AttendingUsersList = [];
      this.eventService.addPresent(id, this.id).subscribe((res) => {
        this.eventService.getAllEvents(this.id).subscribe((res) => {
          res.forEach((value) => {
            value.attendees.forEach((user) => {
              this.AttendingUsersList.push(user.id);
            });
          });
        });
      });
    }
  }

  AttendingUsersTomodel(id) {
    if (id) {
      this.eventService.getEventsById(id).subscribe((res) => {
        this.AttendingUsers = res.attendees;
        this.eventService.getEvents(this.id).subscribe((res) => {
          this.eventList = res;
          this.currentEventLength = res[0].event.length;
          res[0].event.forEach((element) => {
            this.totalVotesCount = this.totalVotesCount + element.votes;
          });
        });
      });

      $("#group_modal").modal("show");
    }
  }

  facebookShare(feed) {
    if (feed.id) {
      const loginOptions: LoginOptions = {
        enable_profile_selector: true,
        return_scopes: true,
        scope: "public_profile,user_friends,email",
      };

      this.fbook
        .login(loginOptions)
        .then((res: LoginResponse) => {
          this.ngZone.run(() => {
            this.sharePost(feed);
          });
        })
        .catch(this.handleError);
    }
  }

  private handleError(error) {
    console.error("Error processing action", error);
  }

  sharePost(feed) {
    var desc = feed.content
      ? feed.content
      : feed.eventDescription
      ? feed.eventDescription
      : feed.description
      ? feed.description
      : "mycoop";
    desc = desc.replace(/&nbsp;/g, "");
    var wrapper = document.createElement("div");
    wrapper.innerHTML = desc;
    desc = wrapper.innerText;
    if (desc.length > 150) {
      desc = desc.slice(0, 150) + "...";
    }

    var object = {
      "og:url": environment.clientUrl, // your url to share
      "og:title": feed.title,
      "og:site_name": "mycoop",
      "og:description": desc,
    };

    if (feed.image) {
      object["og:image"] = environment.s3BucketApi + feed.image[0].fd;
      object["og:image:width"] = "200";
      object["og:image:height"] = "200";
    }

    this.fbook
      .ui({
        method: "share_open_graph",
        action_type: "og.shares",
        action_properties: JSON.stringify({
          object: object,
        }),
      })
      .catch((e: any) => {
        console.log("ffffff", e);
      });
  }

  uploadFunction(uploadButton, formType) {
    console.log(formType, "XNX");
    if (formType === "mainform") {
      this.showFileName = true;
    } else if (formType === "subform") {
      this.showFileName = false;
    }
    $(uploadButton).trigger("click");
  }

  fileChange(files) {
    this.fileList = files.target.files;
    this.fileChanged = "true";
    if (this.fileList.length > 0) {
      this.file = this.fileList[0];
      this.fileName = this.file.name;

      var Extension = this.file.name
        .substring(this.file.name.lastIndexOf(".") + 1)
        .toLowerCase();

      if (
        Extension == "gif" ||
        Extension == "png" ||
        Extension == "bmp" ||
        Extension == "jpeg" ||
        Extension == "jpg"
      ) {
        if (this.file.size > 1024 * 1024 * 20) {
          alert("Maximum file size should be 20mb");
          this.file = null;
        } else {
          this.tempPath = "image";
        }
      } else {
        alert("Allowed files- gif, png, jpeg, jpg, bmp");
        this.file = null;
      }
    }
  }

  displayTourGuide(userId) {
    var that = this;
    if ($(window).innerWidth() > 991) {
      $(".tooltipSetter.firstOne").css("display", "initial");
    }
    var guideCount = 1;
    $(".tooltipSetter .nextBtn").click(function () {
      guideCount++;
      var orderId = $(this).attr("data-order");
      var orderIdnum = parseInt(orderId, 10) + 1;
      var nextElem = $('.nextBtn[data-order ="' + orderIdnum + '"]');
      if (guideCount == orderIdnum) {
        $(this).parents(".tooltipSetter").css("display", "none");
        $(nextElem).parents(".tooltipSetter").css("display", "initial");
      }
    });
    $(".tooltipSetter .doneTour").click(function () {
      $(".tooltipSetter").css("display", "none");
      that._http.updateDoneTour(userId).subscribe((res) => {});
    });
  }

  groupEvent(groupId, eleRef, groupName) {
    this.leavingGroupName = groupName;
    this.leavingGroupId = groupId;
    this.leavingGroupRef = eleRef;
    var actionState = $(eleRef).attr("actionState");

    if (eleRef == "leaveGroup") {
      $("#confirm_modal").modal();
    } else if (eleRef == "joinGroup") {
      this._groupService.joinGroup({ groupId: groupId }).subscribe((res) => {
        if (res) {
          if (res.success == true) {
            this.chatService.eventEmit$.next({
              groupReset: true,
              clearAllGroups: true,
            });
            setTimeout(() => {
              this._feed.getPostByPostId(groupId).subscribe((feed) => {
                this.AllFeeds = this.AllFeeds.map(function (item) {
                  return item.id == feed.id ? feed : item;
                });
              });
            }, 2000);
          } else {
          }
        }
      });
    }
  }

  groupEventLeaving() {
    this._groupService
      .leaveGroup({ groupId: this.leavingGroupId })
      .subscribe((res) => {
        if (res) {
          if (res.success == true) {
            this.chatService.eventEmit$.next({
              groupReset: true,
              clearAllGroups: true,
            });
            setTimeout(() => {
              this._feed
                .getPostByPostId(this.leavingGroupId)
                .subscribe((feed) => {
                  this.AllFeeds = this.AllFeeds.map(function (item) {
                    return item.id == feed.id ? feed : item;
                  });
                });
            }, 2000);
          }
        }
      });
  }

  getRecentBuildingAlerts(id) {
    //if(this.onceCheck == false) {
    this.onceCheck = true;
    // if (this.isManager === 'true') {
    //   this.buildingService.getLatestBuildingAlerts(this.id).subscribe(
    //     (data) => {
    //       //console.log('Building Alerts : ', data.alerts);
    //       if (data.success) {
    //         this.buildingAlerts = data.alerts;
    //         this.buildingAlertsLength = (this.buildingAlerts.length > 0) ? this.buildingAlerts.length : 0;
    //         setTimeout(() => { this.onceCheck = false; }, 2000);
    //       }
    //     }
    //   );
    //} else {
    return new Promise((resolve, reject) => {
      this.buildingService
        .getLatestBuildingAlertsByBuildingId(id)
        .subscribe((data) => {
          //console.log('Building Alerts : ', data);
          if (data.success) {
            resolve(data);

            setTimeout(() => {
              this.onceCheck = false;
            }, 100);
          }
        });
    });

    //}
    //}
  }

  popularitySort(event) {
    if (this.updatedPosts.length > 0) {
      this.updatedPosts.forEach((feed) => {
        this.AllFeeds = this.AllFeeds.map(function (item) {
          return item.id == feed.id ? feed : item;
        });
      });
    }

    if (event.target.value == "Rating") {
      this.AllFeeds.sort(function (data1, data2) {
        console.log(data1, data2);
        var c: any = data1.ratingCount;
        var d: any = data2.ratingCount;
        if (c > d) return -1;
        if (c < d) return 1;
        return 0;
      });
    } else if (event.target.value == "By Date") {
      this.AllFeeds.sort(function (date1, date2) {
        var c: any = new Date(date1.createdAt);
        var d: any = new Date(date2.createdAt);
        if (c > d) return -1;
        if (c < d) return 1;
        return 0;
      });
    }
  }

  calendarOpen(current) {
    event.stopPropagation();
    $(current).find(".add-to-calendar-checkbox").trigger("click");
  }

  modalHideDetect() {
    var that = this;
    $("#create_event_modal").on("hide.bs.modal", function () {
      that.groupArray = [];
      that.groupResult = [];
      that.groupNames = [];
      that.Names = "";
      that.file = null;
      that.tempPath = null;
      $("div.checkbox_inputs")
        .find('input[type="checkbox"]')
        .each(function (index, ele) {
          // console.log('is Checked valv', $(this).prop('checked'));
          $(this).prop("checked", false);
        });
    });

    $("#edit_maintanence_modal").on("hide.bs.modal", function () {
      //console.log('eeeee.e.e.e.e.ee.e.e.')
      that.file = null;
      that.tempPath = null;
    });
  }

  getUsers() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "get",
        dataType: "json",
        headers: {
          authorization: localStorage.getItem("token"),
        },
        async: true,
        url: environment.apiUrl + "users/getUsers", // "/CreateTicket/getCustomerProjects"
        success: function (data) {
          //console.log(data, "ssssssssssssssssssssssss")
          //result = data;
          resolve(data.users);
        },
      });
    });
  }

  mentionedUsers(content) {
    return new Promise((resolve) => {
      try {
        let atags = $(content).find("a");
        let data;
        let mentionedUsers = [];
        $(atags).each(function (index, element) {
          //console.log($( this ).attr('data.email'));
          data = {};
          data["email"] = $(this).attr("data.email");
          data["id"] = $(this).attr("data.id");
          mentionedUsers.push(data);
        });
        mentionedUsers = mentionedUsers.filter(
          (v, i, a) => i === a.findIndex((t) => t.id === v.id)
        );

        resolve(mentionedUsers);
      } catch (e) {
        console.log("Error", e);
        resolve([]);
      }
    });
  }
}
